import { render, staticRenderFns } from "./fdInventory5.vue?vue&type=template&id=3ba2d915"
import script from "./fdInventory5.vue?vue&type=script&lang=js"
export * from "./fdInventory5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports